// Remembered in this browser with `readStorage` and `writeStorage`.
export const timesheetPreferenceKeys = {
  person: 'c-sheet:timesheet:person',
  project: 'c-sheet:timesheet:project',
  task: 'c-sheet:timesheet:task',
  billable: 'c-sheet:timesheet:billable',
  everyone: 'c-sheet:timesheet:everyone'
} as const
